import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="text-9xl md:text-[10rem] font-black text-background-200 font-heading mb-4">404</div>
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 font-heading mb-2">
          页面未找到
        </h1>
        <p className="text-foreground-500 text-sm mb-2">
          请求的页面 <code className="text-primary-600 bg-primary-50 px-1.5 py-0.5 rounded text-xs">{location.pathname}</code> 不存在
        </p>
        <p className="text-foreground-400 text-sm mb-8">
          请检查链接是否正确，或返回首页浏览更多内容
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-lg text-sm font-medium transition-colors"
        >
          返回首页
          <i className="ri-home-line"></i>
        </Link>
      </div>
    </div>
  );
}